/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class RenderingThrottler {
  constructor(func) {
    this.func = func;
    this.lastArgs = null;
    this.isProcessing = false;
  }

  render(...args) {
    this.lastArg = args;
    this._process();
  }

  _process() {
    if (this.isProcessing || !this.lastArg) return;

    this.isProcessing = true;
    this.func(...this.lastArg);
    this.lastArg = null;

    setTimeout(() => {
      this.isProcessing = false;
      this._process();
    }, 0);
  }
}

export const throttle = func => {
  const renderingThrottler = new RenderingThrottler(func);
  return renderingThrottler.render.bind(renderingThrottler);
};
